import clsx from "clsx";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Api } from "@/api";

import styles from "./index.module.scss";

export default function ClientComments() {
  const { products } = useSelector((state: any) => state.section);
  const { params: filterParams } = useSelector((state: any) => state.filter);
  const [clientComments, setClientComments] = useState([]);

  const router = useRouter();

  useEffect(() => {
    const getClientComments = async () => {
      setClientComments(
        await Api.server.getClientComments(
          window.location.pathname,
          filterParams.marka?.[0],
          filterParams.model?.[0],
          filterParams.kuzov?.[0],
          window.location.host,
          Boolean(router.query.reset),
        ),
      );
    };
    getClientComments();
  }, [products]);

  // @ts-ignore
  return clientComments?.length > 0 ? (
    <div className={clsx(styles.Comment)}>
      <div>
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.9997 9.66634L14.9997 17.333M14.9997 20.333L14.9863 20.333M1.66634 14.9997C1.66634 7.63587 7.63588 1.66634 14.9997 1.66634C22.3635 1.66634 28.333 7.63587 28.333 14.9997C28.333 22.3635 22.3635 28.333 14.9997 28.333C7.63588 28.333 1.66634 22.3635 1.66634 14.9997Z"
            stroke="#FF584C"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div>
        {clientComments.map((comment: any) => (
          <div key={comment.NAME}>
            {comment.TEXT && <div>{comment.TEXT}</div>}
          </div>
        ))}
      </div>
    </div>
  ) : null;
}
